import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthOtpResponse, SendEmailCodeResponse, SendSmsCodeResponse, HStreamCallbackResponse } from 'api/AuthApi';
import { authOtp, sendEmailCode, sendSmsCode, sendSmsCodeForApplicationId, hstreamCallback } from 'thunks';

export interface AuthData {
  phoneId?: string;
  emailId?: string;
  sessionToken?: string;
  idToken?: string;
  accessToken?: string;
  refreshToken?: string;
  expiresIn?: number;
  tokenType?: string;
  hstreamUserInfo?: HStreamCallbackResponse;
}

const initialState: AuthData = {};

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sendSmsCode.fulfilled, (state, { payload }: PayloadAction<SendSmsCodeResponse>) => {
      state.phoneId = payload.phoneId;
    });
    builder.addCase(sendSmsCodeForApplicationId.fulfilled, (state, { payload }: PayloadAction<SendSmsCodeResponse>) => {
      state.phoneId = payload.phoneId;
    });
    builder.addCase(sendEmailCode.fulfilled, (state, { payload }: PayloadAction<SendEmailCodeResponse>) => {
      state.emailId = payload.emailId;
    });
    builder.addCase(authOtp.fulfilled, (state, { payload }: PayloadAction<AuthOtpResponse>) => {
      if (payload.verified) {
        state.sessionToken = payload.sessionToken;
      }
    });
    builder.addCase(hstreamCallback.fulfilled, (state, { payload }: PayloadAction<HStreamCallbackResponse>) => {
      state.idToken = payload.tokens.idToken;
      state.accessToken = payload.tokens.accessToken;
      state.refreshToken = payload.tokens.refreshToken;
      state.expiresIn = payload.tokens.expiresIn;
      state.tokenType = payload.tokens.tokenType;
      state.hstreamUserInfo = payload;

      // Set sessionToken from idToken for compatibility with existing auth flow
      state.sessionToken = payload.tokens.idToken;
    });
  },
});

export default auth.reducer;
